import React, { useState } from "react";

// TuLender Score Quiz - MVP
// Brand colors from logo: Navy #0B2545, Gold #D4A929, Red #D83535
// 15 Questions | Max 275 Points | Bilingual (ES/EN)

const TuLenderScoreQuiz = ({ onQuizStart, onQuizComplete, onEmailSubmit }) => {
  const [currentStep, setCurrentStep] = useState(-1);
  const [language, setLanguage] = useState("es");
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [email, setEmail] = useState("");

  const questions = {
    es: [
      {
        id: "credit_score",
        question: "¿Cuál es tu puntaje de crédito aproximado?",
        subtitle: "Muchos compradores primerizos no lo saben — es normal.",
        type: "single",
        options: [
          { value: "poor", label: "300–579", points: 5 },
          { value: "fair", label: "580–669", points: 10 },
          { value: "good", label: "670–739", points: 20 },
          { value: "very_good", label: "740–799", points: 25 },
          { value: "excellent", label: "800+", points: 25 },
          { value: "unknown", label: "No lo sé", points: 0 },
        ],
      },
      {
        id: "down_payment",
        question: "¿Cuánto tienes ahorrado para el enganche?",
        subtitle: "Esto ayuda a determinar elegibilidad FHA / convencional.",
        type: "single",
        options: [
          { value: "0-5k", label: "$0 – $5,000", points: 5 },
          { value: "5-15k", label: "$5,000 – $15,000", points: 15 },
          { value: "15-30k", label: "$15,000 – $30,000", points: 20 },
          { value: "30k+", label: "$30,000+", points: 25 },
        ],
      },
      {
        id: "monthly_income",
        question: "¿Cuál es tu ingreso mensual del hogar (antes de impuestos)?",
        type: "single",
        options: [
          { value: "under_3k", label: "Menos de $3,000", points: 5 },
          { value: "3-5k", label: "$3,000 – $5,000", points: 10 },
          { value: "5-8k", label: "$5,000 – $8,000", points: 15 },
          { value: "8-12k", label: "$8,000 – $12,000", points: 20 },
          { value: "12k+", label: "$12,000+", points: 25 },
        ],
      },
      {
        id: "monthly_debt",
        question: "¿Cuánto pagas mensualmente en deudas?",
        subtitle:
          "Incluye pagos de auto, tarjetas de crédito, préstamos estudiantiles. NO incluyas renta o servicios.",
        type: "single",
        options: [
          { value: "none", label: "$0 - Sin deudas", points: 25 },
          { value: "under_300", label: "Menos de $300", points: 20 },
          { value: "300_600", label: "$300 - $600", points: 18 },
          { value: "600_1000", label: "$600 - $1,000", points: 15 },
          { value: "1000_1500", label: "$1,000 - $1,500", points: 12 },
          { value: "over_1500", label: "Más de $1,500", points: 8 },
          {
            value: "not_sure",
            label: "No estoy seguro/a (lo calculamos juntos)",
            points: 10,
          },
        ],
      },
      {
        id: "employment_status",
        question: "¿Cuál es tu situación laboral actual?",
        type: "single",
        options: [
          {
            value: "full_time",
            label: "Empleado de tiempo completo",
            points: 25,
          },
          { value: "part_time", label: "Empleado de medio tiempo", points: 15 },
          {
            value: "self_employed",
            label: "Trabajador independiente",
            points: 20,
          },
          {
            value: "contractor",
            label: "Contratista independiente / 1099",
            points: 15,
          },
          { value: "unemployed", label: "Actualmente sin empleo", points: 0 },
        ],
      },
      {
        id: "work_history",
        question:
          "¿Cuánto tiempo llevas trabajando en tu empleo o campo actual?",
        subtitle:
          "La mayoría de los prestamistas quieren 2 años de historial laboral.",
        type: "single",
        options: [
          { value: "under_6mo", label: "Menos de 6 meses", points: 5 },
          { value: "6mo-1yr", label: "6 meses – 1 año", points: 10 },
          { value: "1-2yr", label: "1 – 2 años", points: 15 },
          { value: "2yr+", label: "2+ años", points: 25 },
        ],
      },
      {
        id: "documents",
        question: "¿Tienes alguno de estos documentos disponibles?",
        subtitle: "Selecciona todos los que apliquen",
        type: "multiple",
        options: [
          {
            value: "pay_stubs",
            label: "Talones de pago (últimos 2 meses)",
            points: 5,
          },
          {
            value: "tax_returns",
            label: "Declaraciones de impuestos (últimos 2 años)",
            points: 5,
          },
          {
            value: "bank_statements",
            label: "Estados de cuenta bancarios",
            points: 5,
          },
          { value: "w2", label: "Formularios W-2", points: 5 },
          { value: "none", label: "Ninguno de estos todavía", points: 0 },
        ],
      },
      {
        id: "identification",
        question: "¿Qué tipo de identificación tienes?",
        subtitle: "Importante para compradores hispanos.",
        type: "single",
        options: [
          { value: "ssn", label: "Número de Seguro Social (SSN)", points: 20 },
          { value: "itin", label: "ITIN", points: 20 },
          { value: "both", label: "Ambos", points: 20 },
          { value: "prefer_not", label: "Prefiero no decir", points: 10 },
        ],
      },
      {
        id: "military_service",
        question:
          "¿Estás actualmente sirviendo o has servido en el ejército de los EE. UU.?",
        subtitle:
          "Los veteranos califican para préstamos VA con 0% de enganche.",
        type: "single",
        options: [
          {
            value: "currently_serving",
            label: "Actualmente sirviendo",
            points: 15,
          },
          { value: "veteran", label: "Veterano", points: 15 },
          { value: "spouse", label: "Cónyuge de militar/veterano", points: 10 },
          { value: "no", label: "No", points: 5 },
        ],
      },
      {
        id: "first_time",
        question: "¿Eres comprador de vivienda por primera vez?",
        type: "single",
        options: [
          { value: "yes", label: "Sí", points: 10 },
          { value: "no", label: "No", points: 10 },
          { value: "not_sure", label: "No estoy seguro/a", points: 5 },
        ],
      },
      {
        id: "goal",
        question: "¿Qué estás buscando hacer?",
        type: "single",
        options: [
          { value: "first_home", label: "Comprar mi primera casa", points: 10 },
          { value: "another_home", label: "Comprar otra casa", points: 10 },
          {
            value: "refinance",
            label: "Refinanciar mi hipoteca actual",
            points: 10,
          },
          { value: "exploring", label: "Solo explorando opciones", points: 5 },
        ],
      },
      {
        id: "property_type",
        question: "¿Qué tipo de propiedad te interesa?",
        type: "single",
        options: [
          { value: "single_family", label: "Casa unifamiliar", points: 10 },
          { value: "condo", label: "Condominio / Townhouse", points: 10 },
          {
            value: "multi_family",
            label: "Multifamiliar (dúplex, triplex, fourplex)",
            points: 10,
          },
          { value: "mobile", label: "Casa móvil / Manufacturada", points: 10 },
          { value: "not_sure", label: "No estoy seguro/a todavía", points: 5 },
        ],
      },
      {
        id: "timeline",
        question: "¿Cuándo planeas comprar?",
        type: "single",
        options: [
          { value: "asap", label: "Lo antes posible", points: 15 },
          { value: "3-6mo", label: "Dentro de 3–6 meses", points: 10 },
          { value: "6-12mo", label: "Dentro de 6–12 meses", points: 5 },
          { value: "1yr+", label: "1+ año", points: 3 },
        ],
      },
      {
        id: "colorado_location",
        question: "¿Dónde planeas comprar una casa en Colorado?",
        type: "single",
        options: [
          {
            value: "denver_metro",
            label: "Área Metropolitana de Denver",
            points: 10,
          },
          { value: "colorado_springs", label: "Colorado Springs", points: 10 },
          { value: "pueblo", label: "Pueblo", points: 10 },
          {
            value: "elsewhere_co",
            label: "Otro lugar en Colorado",
            points: 10,
          },
          { value: "not_sure", label: "Todavía no estoy seguro/a", points: 5 },
        ],
      },
      {
        id: "lender_contact",
        question: "¿Has hablado con un prestamista o profesional hipotecario?",
        type: "single",
        options: [
          {
            value: "pre_approved",
            label: "Sí, he sido pre-aprobado/a",
            points: 15,
          },
          {
            value: "talked_not_approved",
            label: "Sí, pero no pre-aprobado/a",
            points: 10,
          },
          { value: "not_yet", label: "No, todavía no", points: 5 },
        ],
      },
    ],
    en: [
      {
        id: "credit_score",
        question: "What's your approximate credit score?",
        subtitle: "Many first-time buyers don't know — that's normal.",
        type: "single",
        options: [
          { value: "poor", label: "300–579", points: 5 },
          { value: "fair", label: "580–669", points: 10 },
          { value: "good", label: "670–739", points: 20 },
          { value: "very_good", label: "740–799", points: 25 },
          { value: "excellent", label: "800+", points: 25 },
          { value: "unknown", label: "I don't know", points: 0 },
        ],
      },
      {
        id: "down_payment",
        question: "How much do you have saved for a down payment?",
        subtitle: "This helps determine FHA / conventional eligibility.",
        type: "single",
        options: [
          { value: "0-5k", label: "$0 – $5,000", points: 5 },
          { value: "5-15k", label: "$5,000 – $15,000", points: 15 },
          { value: "15-30k", label: "$15,000 – $30,000", points: 20 },
          { value: "30k+", label: "$30,000+", points: 25 },
        ],
      },
      {
        id: "monthly_income",
        question: "What is your monthly household income (before taxes)?",
        type: "single",
        options: [
          { value: "under_3k", label: "Less than $3,000", points: 5 },
          { value: "3-5k", label: "$3,000 – $5,000", points: 10 },
          { value: "5-8k", label: "$5,000 – $8,000", points: 15 },
          { value: "8-12k", label: "$8,000 – $12,000", points: 20 },
          { value: "12k+", label: "$12,000+", points: 25 },
        ],
      },
      {
        id: "monthly_debt",
        question: "How much do you pay each month in debts?",
        subtitle:
          "Include: car payments, credit cards, student loans. DO NOT include rent, utilities, or groceries.",
        type: "single",
        options: [
          { value: "none", label: "$0 - I don't have any debts", points: 25 },
          { value: "under_300", label: "Less than $300", points: 20 },
          { value: "300_600", label: "$300 - $600", points: 18 },
          { value: "600_1000", label: "$600 - $1,000", points: 15 },
          { value: "1000_1500", label: "$1,000 - $1,500", points: 12 },
          { value: "over_1500", label: "More than $1,500", points: 8 },
          {
            value: "not_sure",
            label: "I'm not sure (we'll review this together)",
            points: 10,
          },
        ],
      },
      {
        id: "employment_status",
        question: "What is your current employment status?",
        type: "single",
        options: [
          { value: "full_time", label: "Full-time employee", points: 25 },
          { value: "part_time", label: "Part-time employee", points: 15 },
          { value: "self_employed", label: "Self-employed", points: 20 },
          {
            value: "contractor",
            label: "Independent contractor / 1099",
            points: 15,
          },
          { value: "unemployed", label: "Not currently employed", points: 0 },
        ],
      },
      {
        id: "work_history",
        question:
          "How long have you been working at your current job or field?",
        subtitle: "Most lenders want 2 years of work history.",
        type: "single",
        options: [
          { value: "under_6mo", label: "Less than 6 months", points: 5 },
          { value: "6mo-1yr", label: "6 months – 1 year", points: 10 },
          { value: "1-2yr", label: "1 – 2 years", points: 15 },
          { value: "2yr+", label: "2+ years", points: 25 },
        ],
      },
      {
        id: "documents",
        question: "Do you have any of these documents available?",
        subtitle: "Check all that apply",
        type: "multiple",
        options: [
          { value: "pay_stubs", label: "Pay stubs (last 2 months)", points: 5 },
          {
            value: "tax_returns",
            label: "Tax returns (last 2 years)",
            points: 5,
          },
          { value: "bank_statements", label: "Bank statements", points: 5 },
          { value: "w2", label: "W-2 forms", points: 5 },
          { value: "none", label: "None of these yet", points: 0 },
        ],
      },
      {
        id: "identification",
        question: "What type of identification do you have?",
        subtitle: "Important for Hispanic buyers.",
        type: "single",
        options: [
          { value: "ssn", label: "Social Security Number (SSN)", points: 20 },
          { value: "itin", label: "ITIN", points: 20 },
          { value: "both", label: "Both", points: 20 },
          { value: "prefer_not", label: "Prefer not to say", points: 10 },
        ],
      },
      {
        id: "military_service",
        question:
          "Are you currently serving or have you served in the U.S. military?",
        subtitle: "Veterans qualify for VA loans with 0% down payment.",
        type: "single",
        options: [
          {
            value: "currently_serving",
            label: "Currently serving",
            points: 15,
          },
          { value: "veteran", label: "Veteran", points: 15 },
          { value: "spouse", label: "Military/veteran spouse", points: 10 },
          { value: "no", label: "No", points: 5 },
        ],
      },
      {
        id: "first_time",
        question: "Are you a first-time homebuyer?",
        type: "single",
        options: [
          { value: "yes", label: "Yes", points: 10 },
          { value: "no", label: "No", points: 10 },
          { value: "not_sure", label: "Not sure", points: 5 },
        ],
      },
      {
        id: "goal",
        question: "What are you looking to do?",
        type: "single",
        options: [
          { value: "first_home", label: "Buy my first home", points: 10 },
          { value: "another_home", label: "Buy another home", points: 10 },
          {
            value: "refinance",
            label: "Refinance my current mortgage",
            points: 10,
          },
          { value: "exploring", label: "Just exploring options", points: 5 },
        ],
      },
      {
        id: "property_type",
        question: "What type of property are you interested in?",
        type: "single",
        options: [
          { value: "single_family", label: "Single-family home", points: 10 },
          { value: "condo", label: "Condo / Townhome", points: 10 },
          {
            value: "multi_family",
            label: "Multi-family (duplex, triplex, fourplex)",
            points: 10,
          },
          { value: "mobile", label: "Mobile / Manufactured home", points: 10 },
          { value: "not_sure", label: "Not sure yet", points: 5 },
        ],
      },
      {
        id: "timeline",
        question: "When are you planning to buy?",
        type: "single",
        options: [
          { value: "asap", label: "As soon as possible", points: 15 },
          { value: "3-6mo", label: "Within 3–6 months", points: 10 },
          { value: "6-12mo", label: "Within 6–12 months", points: 5 },
          { value: "1yr+", label: "1+ year", points: 3 },
        ],
      },
      {
        id: "colorado_location",
        question: "Where are you planning to buy a home in Colorado?",
        type: "single",
        options: [
          { value: "denver_metro", label: "Denver Metro Area", points: 10 },
          { value: "colorado_springs", label: "Colorado Springs", points: 10 },
          { value: "pueblo", label: "Pueblo", points: 10 },
          {
            value: "elsewhere_co",
            label: "Somewhere else in Colorado",
            points: 10,
          },
          { value: "not_sure", label: "I'm not sure yet", points: 5 },
        ],
      },
      {
        id: "lender_contact",
        question: "Have you spoken with a lender or mortgage professional yet?",
        type: "single",
        options: [
          {
            value: "pre_approved",
            label: "Yes, I have been pre-approved",
            points: 15,
          },
          {
            value: "talked_not_approved",
            label: "Yes, but not pre-approved",
            points: 10,
          },
          { value: "not_yet", label: "No, not yet", points: 5 },
        ],
      },
    ],
  };

  const text = {
    es: {
      title: "Descubre tu TuLender Score",
      subtitle: "¿Estás listo para comprar casa?",
      description:
        "Responde 15 preguntas rápidas y descubre tu nivel de preparación para comprar vivienda.",
      startButton: "Comenzar Evaluación",
      nextButton: "Siguiente",
      backButton: "Atrás",
      submitButton: "Ver Mi Puntaje",
      resultTitle: "Tu TuLender Score",
      emailPlaceholder: "tu@email.com",
      emailButton: "Enviar Mi Plan Personalizado",
      progressLabel: "Pregunta",
    },
    en: {
      title: "Discover Your TuLender Score",
      subtitle: "Are you ready to buy a home?",
      description:
        "Answer 15 quick questions and discover your homebuyer readiness level.",
      startButton: "Start Assessment",
      nextButton: "Next",
      backButton: "Back",
      submitButton: "See My Score",
      resultTitle: "Your TuLender Score",
      emailPlaceholder: "your@email.com",
      emailButton: "Send My Personalized Plan",
      progressLabel: "Question",
    },
  };

  const calculateScore = () => {
    let totalPoints = 0;
    const maxPoints = 275; // Fixed: 15 questions, max 275 points

    questions[language].forEach((q) => {
      const answer = answers[q.id];

      if (q.type === "multiple" && Array.isArray(answer)) {
        // For documents question (allows multiple selections)
        answer.forEach((val) => {
          const option = q.options.find((opt) => opt.value === val);
          if (option) totalPoints += option.points;
        });
      } else if (q.type === "single" && answer) {
        // For all other questions (single selection)
        const option = q.options.find((opt) => opt.value === answer);
        if (option) totalPoints += option.points;
      }
    });

    return Math.round((totalPoints / maxPoints) * 100);
  };

  const getScoreCategory = (score) => {
    if (score >= 85)
      return {
        es: {
          label: "Listo para Comprar",
          color: "#D4A929",
          message: "¡Excelente! Estás muy bien preparado para comprar casa.",
        },
        en: {
          label: "Ready to Buy",
          color: "#D4A929",
          message: "Excellent! You're very well prepared to buy a home.",
        },
      };

    if (score >= 70)
      return {
        es: {
          label: "Casi Listo",
          color: "#D4A929",
          message: "Muy bien! Solo necesitas algunos ajustes pequeños.",
        },
        en: {
          label: "Almost Ready",
          color: "#D4A929",
          message: "Great! You just need a few small adjustments.",
        },
      };

    if (score >= 50)
      return {
        es: {
          label: "En Progreso",
          color: "#0B2545",
          message:
            "Vas por buen camino. Te ayudaremos a mejorar tu preparación.",
        },
        en: {
          label: "Getting Ready",
          color: "#0B2545",
          message:
            "You're on the right track. We'll help you improve your readiness.",
        },
      };

    return {
      es: {
        label: "Construyendo Bases",
        color: "#0B2545",
        message:
          "Estás al inicio del proceso. ¡No te preocupes, te guiaremos paso a paso!",
      },
      en: {
        label: "Building Foundation",
        color: "#0B2545",
        message:
          "You're at the beginning. Don't worry, we'll guide you step by step!",
      },
    };
  };

  const handleAnswer = (questionId, value, isMultiple) => {
    if (isMultiple) {
      const currentAnswers = answers[questionId] || [];
      setAnswers({
        ...answers,
        [questionId]: currentAnswers.includes(value)
          ? currentAnswers.filter((v) => v !== value)
          : [...currentAnswers, value],
      });
    } else {
      setAnswers({ ...answers, [questionId]: value });
    }
  };

  const currentQuestion =
    currentStep >= 0 ? questions[language][currentStep] : null;
  const progress =
    currentStep >= 0
      ? ((currentStep + 1) / questions[language].length) * 100
      : 0;
  const score = showResults ? calculateScore() : 0;
  const scoreCategory = showResults ? getScoreCategory(score) : null;

  return (
    <div
      style={{
        fontFamily: '"DM Sans", system-ui, -apple-system, sans-serif',
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Playfair+Display:wght@700;900&display=swap');
        
        .option-button {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .option-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(11, 37, 69, 0.15);
        }
        
        .score-circle {
          animation: scoreReveal 1s ease-out;
        }
        
        @keyframes scoreReveal {
          from {
            transform: scale(0) rotate(-180deg);
            opacity: 0;
          }
          to {
            transform: scale(1) rotate(0deg);
            opacity: 1;
          }
        }
        
        .progress-bar {
          transition: width 0.5s ease;
        }
      `}</style>

      {/* Header */}
      <div
        style={{
          background: "#0B2545",
          padding: "1.5rem 0",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            padding: "0 1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "white",
              fontSize: "1.5rem",
              fontWeight: "700",
              fontFamily: '"Playfair Display", serif',
            }}
          >
            Tu<span style={{ color: "#D4A929" }}>Lender</span> Score
          </div>
          <button
            onClick={() => setLanguage(language === "es" ? "en" : "es")}
            style={{
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.3)",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "20px",
              cursor: "pointer",
              fontSize: "0.875rem",
              fontWeight: "500",
            }}
          >
            {language === "es" ? "English" : "Español"}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div
        style={{ maxWidth: "700px", margin: "3rem auto", padding: "0 1.5rem" }}
      >
        {!showResults ? (
          currentStep === -1 ? (
            // Welcome Screen
            <div
              style={{
                background: "white",
                borderRadius: "16px",
                padding: "3rem 2.5rem",
                boxShadow: "0 4px 20px rgba(11, 37, 69, 0.08)",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  margin: "0 auto 2rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/tulender-logo.png"
                  alt="TuLender"
                  style={{
                    height: "180px",
                    width: "auto",
                    filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.1))", // ← Adds shadow
                  }}
                />
              </div>

              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "900",
                  color: "#0B2545",
                  marginBottom: "1rem",
                  fontFamily: '"Playfair Display", serif',
                }}
              >
                {text[language].title}
              </h1>
              <p
                style={{
                  fontSize: "1.25rem",
                  color: "#6c757d",
                  marginBottom: "0.5rem",
                  fontWeight: "500",
                }}
              >
                {text[language].subtitle}
              </p>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#6c757d",
                  marginBottom: "2.5rem",
                  lineHeight: "1.6",
                }}
              >
                {text[language].description}
              </p>
              <button
                onClick={() => {
                  onQuizStart?.(); // 🔥 TRIGGER: Quiz Started
                  setCurrentStep(0);
                }}
                style={{
                  background:
                    "linear-gradient(135deg, #D83535 0%, #D4A929 100%)",
                  color: "white",
                  border: "none",
                  padding: "1rem 3rem",
                  borderRadius: "50px",
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  cursor: "pointer",
                  boxShadow: "0 4px 15px rgba(216, 53, 53, 0.3)",
                  transition: "all 0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                {text[language].startButton}
              </button>
            </div>
          ) : (
            // Question Screen
            <div>
              {/* Progress Bar */}
              <div style={{ marginBottom: "2rem" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "0.5rem",
                    fontSize: "0.875rem",
                    color: "#6c757d",
                    fontWeight: "500",
                  }}
                >
                  <span>
                    {text[language].progressLabel} {currentStep + 1}/
                    {questions[language].length}
                  </span>
                  <span>{Math.round(progress)}%</span>
                </div>
                <div
                  style={{
                    height: "8px",
                    background: "#e9ecef",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="progress-bar"
                    style={{
                      width: `${progress}%`,
                      height: "100%",
                      background:
                        "linear-gradient(90deg, #D83535 0%, #D4A929 100%)",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>

              {/* Question Card */}
              <div
                style={{
                  background: "white",
                  borderRadius: "16px",
                  padding: "2.5rem",
                  boxShadow: "0 4px 20px rgba(11, 37, 69, 0.08)",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#0B2545",
                    marginBottom: "0.5rem",
                  }}
                >
                  {currentQuestion.question}
                </h2>
                {currentQuestion.subtitle && (
                  <p
                    style={{
                      fontSize: "0.875rem",
                      color: "#6c757d",
                      marginBottom: "2rem",
                    }}
                  >
                    {currentQuestion.subtitle}
                  </p>
                )}

                {/* Options */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                  }}
                >
                  {currentQuestion.options.map((option) => {
                    const isSelected =
                      currentQuestion.type === "multiple"
                        ? (answers[currentQuestion.id] || []).includes(
                            option.value,
                          )
                        : answers[currentQuestion.id] === option.value;

                    return (
                      <button
                        key={option.value}
                        className="option-button"
                        onClick={() =>
                          handleAnswer(
                            currentQuestion.id,
                            option.value,
                            currentQuestion.type === "multiple",
                          )
                        }
                        style={{
                          background: isSelected ? "#0B2545" : "white",
                          border: `2px solid ${isSelected ? "#0B2545" : "#dee2e6"}`,
                          color: isSelected ? "white" : "#0B2545",
                          padding: "1rem 1.5rem",
                          borderRadius: "12px",
                          fontSize: "1rem",
                          fontWeight: "500",
                          cursor: "pointer",
                          textAlign: "left",
                          boxShadow: isSelected
                            ? "0 4px 12px rgba(11, 37, 69, 0.2)"
                            : "none",
                        }}
                      >
                        {option.label}
                      </button>
                    );
                  })}
                </div>

                {/* Navigation */}
                <div
                  style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}
                >
                  {currentStep > 0 && (
                    <button
                      onClick={() => setCurrentStep(currentStep - 1)}
                      style={{
                        flex: "1",
                        background: "white",
                        border: "2px solid #dee2e6",
                        color: "#0B2545",
                        padding: "0.875rem",
                        borderRadius: "12px",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      {text[language].backButton}
                    </button>
                  )}
                  <button
                    onClick={() => {
                      if (currentStep === questions[language].length - 1) {
                        const finalScore = calculateScore();
                        onQuizComplete?.(finalScore); // 🔥 TRIGGER: Quiz Completed
                        setShowResults(true);
                      } else {
                        setCurrentStep(currentStep + 1);
                      }
                    }}
                    style={{
                      flex: "2",
                      background:
                        "linear-gradient(135deg, #D83535 0%, #D4A929 100%)",
                      border: "none",
                      color: "white",
                      padding: "0.875rem",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(216, 53, 53, 0.3)",
                    }}
                  >
                    {currentStep === questions[language].length - 1
                      ? text[language].submitButton
                      : text[language].nextButton}
                  </button>
                </div>
              </div>
            </div>
          )
        ) : (
          // Results Screen
          <div
            style={{
              background: "white",
              borderRadius: "16px",
              padding: "3rem 2.5rem",
              boxShadow: "0 4px 20px rgba(11, 37, 69, 0.08)",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#0B2545",
                marginBottom: "2rem",
              }}
            >
              {text[language].resultTitle}
            </h2>

            {/* Score Circle */}
            <div
              className="score-circle"
              style={{
                width: "200px",
                height: "200px",
                borderRadius: "50%",
                background: `conic-gradient(${scoreCategory[language].color} ${score * 3.6}deg, #e9ecef ${score * 3.6}deg)`,
                margin: "0 auto 2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: "170px",
                  height: "170px",
                  borderRadius: "50%",
                  background: "white",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "3.5rem",
                    fontWeight: "900",
                    color: "#0B2545",
                    fontFamily: '"Playfair Display", serif',
                  }}
                >
                  {score}
                </div>
                <div
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: "600",
                    color: "#6c757d",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  /100
                </div>
              </div>
            </div>

            <div
              style={{
                display: "inline-block",
                background: scoreCategory[language].color,
                color: "white",
                padding: "0.5rem 1.5rem",
                borderRadius: "20px",
                fontSize: "0.875rem",
                fontWeight: "700",
                marginBottom: "1rem",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              {scoreCategory[language].label}
            </div>

            <p
              style={{
                fontSize: "1rem",
                color: "#6c757d",
                marginBottom: "2rem",
                lineHeight: "1.6",
              }}
            >
              {scoreCategory[language].message}
            </p>

            {/* Email Capture */}
            <div style={{ maxWidth: "400px", margin: "2rem auto 0" }}>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#6c757d",
                  marginBottom: "1rem",
                }}
              >
                {language === "es"
                  ? "Recibe tu plan personalizado y aprende cómo mejorar tu puntaje"
                  : "Get your personalized plan and learn how to improve your score"}
              </p>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <input
                  type="email"
                  placeholder={text[language].emailPlaceholder}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    flex: "1",
                    padding: "0.875rem 1.25rem",
                    border: "2px solid #dee2e6",
                    borderRadius: "12px",
                    fontSize: "1rem",
                  }}
                />
                <button
                  onClick={async () => {
                    // 1. Basic validation to save your Formspree quota
                    if (!email || !email.includes("@")) {
                      alert(
                        language === "es"
                          ? "Por favor, introduce un correo válido."
                          : "Please enter a valid email.",
                      );
                      return;
                    }
                    onEmailSubmit?.(score); // 🔥 TRIGGER: Email Submitted
                    try {
                      const response = await fetch(
                        "https://formspree.io/f/xaqpdyno",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json", // Tells Formspree not to redirect
                          },
                          body: JSON.stringify({
                            email: email,
                            score: score,
                            language: language,
                            answers: answers, // Send as object, not a stringified string
                            timestamp: new Date().toISOString(),
                          }),
                        },
                      );

                      if (response.ok) {
                        alert(
                          language === "es"
                            ? "¡Gracias! Revisa tu email (incluyendo spam) para tus resultados."
                            : "Thank you! Check your email (including spam) for your results.",
                        );
                        setEmail("");
                      } else {
                        // Handle server errors (e.g. if the form is disabled)
                        const data = await response.json();
                        console.error("Formspree Error:", data);
                        alert(
                          language === "es"
                            ? "Hubo un error al enviar."
                            : "There was an error sending.",
                        );
                      }
                    } catch (error) {
                      console.error("Network Error:", error);
                    }
                  }}
                  style={{
                    background:
                      "linear-gradient(135deg, #D83535 0%, #D4A929 100%)",
                    color: "white",
                    border: "none",
                    padding: "0.875rem 1.5rem",
                    borderRadius: "12px",
                    fontSize: "1rem",
                    fontWeight: "700",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  {language === "es" ? "Enviar" : "Send"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TuLenderScoreQuiz;
